import { useNavigate } from "react-router-dom";

import { withLiteObserverAndTheme } from "../../../core/et3-enhanced-render";
import getCoreHistoryStore from "../../../stores/core/core-history-store";
import { TMenuItemProps } from "../../../Types";
import SideBarRow from "./SideBarRow";

const MenuItem = withLiteObserverAndTheme<TMenuItemProps>((props) => {
  const { title, icon, link, visible } = props;
  const navigate = useNavigate();
  const isActive = getCoreHistoryStore().getPageName() === title;

  return !visible ? null : (
    <SideBarRow
      icon={icon}
      title={title}
      isActive={isActive}
      isOpen={false}
      hasChevron={false}
      onPress={() => navigate({ pathname: link })}
    />
  );
});
export default MenuItem;
